import React, { useState } from 'react';
import omit from 'lodash/omit';
import startCase from 'lodash/startCase';
import shortid from 'shortid';
import {
  ErrorMessage,
  useFormikContext,
} from 'formik';

import FormField from './FormField.jsx';
import FormRadioField from './FormRadioField.jsx';

const FormGroup = (props) => {
  const { status } = useFormikContext();

  const {
    label,
    name,
    radio,
    required = false,
    helpText,
    prependLabel,
    appendLabel,
  } = props;
  const [id] = useState(() => `a${shortid.generate()}`);
  const p = {
    id,
    ...omit(props, ['label', 'required', 'helpText', 'prependLabel', 'appendLabel']),
    ...status,
  };

  return (
    <div className="form-group">
      {label !== null && (
        <label htmlFor={id}>
          {label || startCase(name)}
          {required ? ' *' : ''}
        </label>
      )}
      <div className="input-group">
        {prependLabel && (
          <span className="input-group-text">{prependLabel}</span>
        )}
        {radio ? (
          <FormRadioField {...p} />
        ) : (
          <FormField {...p} />
        )}
        {appendLabel && (
          <span className="input-group-text">{appendLabel}</span>
        )}
      </div>
      {helpText && (
        <small className="form-text text-muted">
          {helpText}
        </small>
      )}
      <ErrorMessage name={name}>
        {(msg) => (
          <div className="invalid-feedback">{msg}</div>
        )}
      </ErrorMessage>
    </div>
  );
};

export default FormGroup;
